import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import loginFormConstant from '../../../../constants/formConstants/loginFormConstant';
import { adminAuthDispatcher } from '../../../../redux/dispatchers/authDispatcher';
import Button from '../../../commons/Button/Button';
import GenerateFormHook from '../../../commons/GenerateFormHook';
import RenderAdminByPermission from './RenderAdminByPermission';

const useStyles = makeStyles((theme) => ({
    loginArea: {
        width: '100%',
        minHeight: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .MuiPaper-root': {
            width: '35rem',
            backgroundColor: theme.palette.ascents.baseDark,
            borderRadius: 16,

            '& h1': {
                fontSize: 36,
                color: theme.palette.primary.main
            }
        }
    },
}));

const AdminLoginScreen = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const methods = useForm();
    const [submitButtonIsLoading, setSubmitButtonIsLoading] = React.useState(false)
    const { enqueueSnackbar } = useSnackbar();

    const handleInvalidLogin = (message) => {
        setSubmitButtonIsLoading(false)
        enqueueSnackbar(message, {
            autoHideDuration: 5000,
            variant: 'error'
        })
    }

    const handleAdminLogin = (data) => {
        setSubmitButtonIsLoading(true);
        dispatch(adminAuthDispatcher(data, handleInvalidLogin))
    }

    return (
        <>
            <RenderAdminByPermission auth={auth} />
            <div className={classes.loginArea}>
                <Paper elevation={0}>
                    <Box p={5}>
                        <Grid container style={{ textAlign: 'center' }}>
                            <Grid item xs={12}>
                                <Typography variant='h1'>Admin Login</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormProvider {...methods}>
                                    <form onSubmit={methods.handleSubmit(handleAdminLogin)}>
                                        <GenerateFormHook control={methods.control} formConstant={loginFormConstant} />
                                        <Button variant='contained' type='submit' color='primary' isLoading={submitButtonIsLoading} fullWidth>Submit</Button>
                                    </form>
                                </FormProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </div>
        </>
    )
}

export default AdminLoginScreen
